export const UserRole = {
	USER: "USER",
	ADMIN: "ADMIN",
	OWNER: "OWNER"
} as const;

export type UserRoleKey = (typeof UserRole)[keyof typeof UserRole];

export const OrganisationType = {
	PERSONAL: "PERSONAL",
	COMPANY: "COMPANY"
} as const;

export type OrganisationTypeKey =
	(typeof OrganisationType)[keyof typeof OrganisationType];

export type OrganisationOverview = {
	id: number;
	name: string;
	smallLogo: string | null;
	largeLogo: string | null;
	role: UserRoleKey;
};

export type OrganisationInfo = {
	id: number;
	name: string;
	slogan: string | null;
	description: string | null;
	type: OrganisationTypeKey;
	smallLogo: string | null;
	largeLogo: string | null;
	vatIdentification: string | null;
	streetName: string;
	streetNumber: string;
	postalCode: string;
	city: string;
	country: string;
	email: string;
	phoneNumber: string;
};

export type EditOrganisationInfo = {
	name: string;
	slogan?: string;
	description?: string;
	type: OrganisationTypeKey;
	smallLogo?: string;
	largeLogo?: string;
	vatIdentification?: string;
	streetName: string;
	streetNumber: string;
	postalCode: string;
	city: string;
	country: string;
	email: string;
	phoneNumber: string;
};
